import { Button } from '@material-ui/core';
import React from 'react';
import { List, Datagrid, BooleanField, TextField, EditButton, ReferenceField, DateField, NumberField,useRedirect } from 'react-admin';
import { Authorizer } from '../../common/Authorizer';
import { DisplayDate } from '../../common/DisplayDate';
import CDeleteButton from '../../common/CDeleteButton';
  
export const EmployeeLeaveList = props => {
    const redirect = useRedirect();
    let propsObj = { ...props };
    if (propsObj.permissions) {
        let resourcename = `/${props.resource}`;
        let myPermissions = propsObj.permissions.filter(item => item.NavigateUrl.toLowerCase().trim() == resourcename);
        propsObj.hasList =  false;
        propsObj.hasShow = false;
        propsObj.hasEdit =  false;
        propsObj.hasDelete = false;
        propsObj.hasCreate = false;
        propsObj.hasExport = false;
        if (myPermissions.length > 0) {
            let p = myPermissions[0];
            propsObj.hasList = (p.View == 1) ? true : false;
            propsObj.hasShow = (p.View == 1) ? true : false;
            propsObj.hasEdit = (p.Edit == 1) ? true : false;
            propsObj.hasDelete = (p.Delete == 1) ? true : false;
            propsObj.hasCreate = (p.Create == 1) ? true : false;
            propsObj.hasExport = (p.Export == 1) ? true : false;
            propsObj = { ...propsObj, ...p }
        }
    }
    let employeeId: any
    employeeId = localStorage.getItem("EmployeeId");
    if (employeeId) {
        employeeId = parseInt(employeeId);
    }
    
    const CustomEditButton = (props) => {
        let { record } = props;
        let leavebutton:any;
        leavebutton="";
        if(!record.isApproved)
        {
            leavebutton=<Button onClick={()=>redirect(`employee-leaves/${record.id}`)} >Edit</Button>
        } 
        return leavebutton;
      }
    
    return (
        <React.Fragment>
            <List {...propsObj} exporter={propsObj.hasExport} bulkActionButtons={false} title="List of Leaves" {...props} filter={{ employeeId: employeeId }}>
                <Datagrid rowClick={false}> 
                    {propsObj.hasEdit &&  <CustomEditButton label="" source="id"/>}
                    {propsObj.hasDelete && <CDeleteButton {...props}/>}
                    <ReferenceField source="employeeId" reference="employees" label="Employee" link={false}>
                        <TextField source="name" />
                    </ReferenceField>
                    <ReferenceField source="leaveTypeId" reference="leave-types" label="Leave Type" link={false}>
                        <TextField source="name" />
                    </ReferenceField>
                    <DisplayDate source="fromDate" label="From Date" locales="fr-FR" />
                    <DisplayDate source="toDate" label="To Date" locales="fr-FR" />
                    <TextField  label="Total Days" source="totalDays"/>
                    <DateField label="Approved From Date" source="approvedFromDate"   locales="fr-FR" />
                    <DateField label="Approved To Date" source="approvedToDate"  locales="fr-FR" />
                    <TextField label="Total Approved Days" source="totalApprovedDays"  />
                    <TextField source="approverRemarks" label='Approver Remarks' fullWidth={true}/>   
                    <BooleanField source="isApproved" label="Is Approved"/>
                    <ReferenceField source="approverId" reference="users" label="Approver" link={false}>
                        <TextField source="userName" />
                    </ReferenceField>
                   <ReferenceField source="createdBy" reference="users" label="Created By" link={false}>
                        <TextField source="userName" />
                    </ReferenceField>
                    <DisplayDate source="createdDate" label="Created Date" locales="fr-FR" />
                    <ReferenceField source="modifyBy" reference="users" label="Updated By" link={false}>
                        <TextField source="userName" />
                    </ReferenceField>
                    <DisplayDate source="modifyDate" label="Updated Date" locales="fr-FR" />  
                </Datagrid>
            </List>
        </React.Fragment>
    );
}